export type COLORS = "primary" | "warning" | "success" | "info" | "error" | "gray";

export enum FileType {
  IMAGE = "IMAGE",
  PDF = "PDF",
  ZIP = "ZIP",
  RAR = "RAR",
  GZ = "GZ",
  PPT = "PPT",
  EXCEL = "EXCEL",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  DOC = "DOC",
  TEXT = "TEXT",
  SQL = "SQL",
  JSON = "JSON",
  XML = "XML",
  OTHER = "OTHER",
}

export class Cls_MobiFile {
  fileName: string = "";
  fileUrl: string = "";
  fileType: string = "";
  fileSize: number = 0;
}

export class Cls_MobiTab {
  tabName: string = "";
  tabValue: string | number = "";
  tabIconPath?: string = "";
  iconTooltip?: string;
  tabBadgeValue?: string | number = "";
}

export class Cls_MobiAsideMenuItems {
  pageName?: string;
  pageUrl?: string;
  isIcon: boolean = false;
  iconName?: string;
  iconClass?: string;
  defaultSvgIcon: string = "";
  selectedSvgIcon: string = "";
}

/**
  columnKey & valueKey should be same and unique.
  headingName : The column heading
  className : Class names given to each row of the table
  columnType : Type of the column data
*/
type ColumnType = "NUMBER" | "INT_NUMBER" | "CURRENCY_DOLLAR" | "CURRENCY_INR" | "DISCOUNT" | "DATE" | "DATE_TIME" | "STRING" | "CHECK_BOX" | "FUNCTION" | "HTML" | "IMAGE";
type ColumnClass = "width-5" | "width-10" | "width-15" | "width-20";
export class Cls_TableColumns {
  columnKey = "";
  headingName = "";
  valueKey = "";
  columnBodyAlignment?: string = "";
  columnHeaderAlignment?: string = "";
  className: ColumnClass | string = "";
  columnType: ColumnType = "STRING";
}

export class Cls_Common {
  IsActive?: boolean = true;
  createdAt?: string;
  createdBy?: number;
  updatedAt?: string;
  updatedBy?: number;
  deletedAt?: string;
  deletedBy?: number;
}
